"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Shape;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function Shape(_ref) {
  var _ref$width = _ref.width,
      width = _ref$width === void 0 ? 330 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 30 : _ref$height,
      strokeWidth = _ref.strokeWidth,
      innerRef = _ref.innerRef,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("svg", {
    version: "1.1",
    viewBox: "0 0 340 30",
    width: width,
    height: height,
    ref: innerRef,
    style: style
  }, /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "0,0 151.5,14.5 0,30 ",
    fill: "white",
    strokeWidth: strokeWidth
  }), /*#__PURE__*/_react["default"].createElement("polygon", {
    points: "340,0 340,30 151.5,14.5 ",
    fill: "white",
    strokeWidth: strokeWidth
  }));
}